import {showSuccessNotification} from "./dialogs";
import locales from "../locales";


export const copyLink = async (link?: string) => {
  if (!link) {
    return;
  }

  try {
    if (navigator.clipboard) {
      await navigator.clipboard.writeText(link);
    } else {
      fallbackCopy(link);
    }

  } catch {
    fallbackCopy(link);
  } finally {
    showSuccessNotification(locales.copied_to_clipboard);
  }
};

export const fallbackCopy = (text: string) => {
  const textarea = document.createElement('textarea');
  textarea.value = text;

  document.body.appendChild(textarea);
  textarea.select();
  document.execCommand('copy');
  document.body.removeChild(textarea);
}



// WEBPACK FOOTER //
// ./src/utils/copy-utils.ts